/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import { ElPagination as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/pagination/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/input/style/css';
import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue";
var _hoisted_1 = {
  class: "header"
};
var _hoisted_2 = {
  class: "contain"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "pagination_"
};
var _hoisted_6 = {
  class: "dialog-footer"
};
import { reactive, watch } from "vue";
import { client_user, client, get_user_list, get_client_list } from "@/api/apis";
import { ElMessage } from "element-plus";
export default {
  __name: 'selectData',
  props: ["isShow", "data_type", "key_word", "use", "multiple", "isNa", "visit_type", "type", 'from'],
  emits: ["close", "onSelectItem", "onSelectList"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var dialogVisible = ref(true);
    var label_filed = ref("");
    watchEffect(() => {
      dialogVisible.value = props.isShow;
    });
    watch(() => {
      return dialogVisible.value;
    }, () => {
      if (!dialogVisible.value) {
        if (props.multiple) {
          data_list.value.map(x => {
            x.is_show = false;
          });
          multiple_list.value = [];
          fy.page = 1;
          key_word.value = "";
        }
        key_word.value = "";
        emit("close");
      }
    });
    watch(() => {
      return props.data_type;
    }, () => {
      if (props.data_type == "联系人" || props.data_type == "用户") {
        label_filed.value = "name";
      } else if (props.data_type == "客户" || props.data_type == "客诉") {
        label_filed.value = "company";
      }
      getlist();
    });
    var data_list = ref([]);
    var key_word = ref("");
    var timer = "";
    watch(() => {
      return key_word.value;
    }, () => {
      if (timer) {
        clearTimeout(timer);
        // timer = "";
      }
      timer = setTimeout(() => {
        getlist();
      }, 500);
    });
    watch(() => {
      return props.visit_type;
    }, () => {
      getlist();
    });
    var fy = reactive({
      limit: 20,
      page: 1,
      total: 0
    });
    var getlist = () => {
      if (props.data_type == "联系人") {
        var obj = {
          page: fy.page,
          limit: fy.limit,
          name: key_word.value
        };
        if (props.key_word) {
          var key_ = Object.keys(props.key_word)[0];
          var value_ = Object.values(props.key_word)[0];
          obj[key_] = value_;
        }
        client_user(obj).then(res => {
          if (res.code == 200) {
            data_list.value = res.data.list;
            fy.total = res.data.total;
          }
        });
      } else if (props.data_type == "客户") {
        var _obj = {
          page: fy.page,
          limit: fy.limit,
          company: key_word.value
        };
        if (props.isNa) {
          _obj.na_type = 1;
        }
        if (props.visit_type == 2) {
          _obj["check_all"] = 1;
        }
        if (props.from == 'quotation' || props.from == 'sample') {
          // 从报价那里来的选择客户，传一个字段客户列表能看到经销商
          _obj['is_distributor'] = 1;
        }
        client(_obj).then(res => {
          if (res.code == 200) {
            data_list.value = res.data.list;
            fy.total = res.data.total;
          }
        });
      } else if (props.data_type == "客诉") {
        var _obj2 = {
          page: fy.page,
          limit: fy.limit,
          key_word: key_word.value
        };
        get_client_list(_obj2).then(res => {
          if (res.code == 200) {
            var _res$data;
            data_list.value = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data;
            fy.total = res.data.total;
          }
        });
      } else if (props.data_type == "用户") {
        get_user_list({
          page: fy.page,
          limit: fy.limit,
          key_word: key_word.value
        }).then(res => {
          if (res.code == 200) {
            if (props.multiple) {
              res.data.data.map(x => {
                if (multiple_list.value.find(b => b.id == x.id)) {
                  x.is_show = true;
                } else {
                  x.is_show = false;
                }
              });
            }
            data_list.value = res.data.data;
            fy.total = res.data.total;
          }
        });
      }
    };
    var handleCurrentChange = () => {
      getlist();
    };
    var select_item = val => {
      if (props.data_type == "用户" && !val.email && props.use != "sample") {
        ElMessage({
          type: "warning",
          message: "无邮箱请联系管理员"
        });
        return false;
      }
      emit("onSelectItem", val);
    };

    /**
     * 多选操作
     */
    var multiple_list = ref([]);
    var select_item_mutiple = item => {
      if (item.is_show) {
        var index_ = multiple_list.value.findIndex(x => x.id == item.id);
        if (index_ != -1) {
          multiple_list.value.splice(index_, 1);
        }
        item.is_show = false;
      } else {
        multiple_list.value.push(item);
        item.is_show = true;
      }
    };
    var handle_multiple = () => {
      if (multiple_list.value.length == 0) {
        ElMessage({
          type: "warning",
          message: "请至少选择一位用户"
        });
        return false;
      }
      emit("onSelectList", multiple_list.value);
    };
    return (_ctx, _cache) => {
      var _component_el_input = __unplugin_components_0;
      var _component_el_pagination = __unplugin_components_1;
      var _component_el_button = __unplugin_components_2;
      var _component_el_dialog = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : dialogVisible = $event),
        title: '选择' + (_unref(props).data_type == '客诉' ? '客户' : _unref(props).data_type),
        style: {
          "width": "700px"
        },
        class: "select_dialog"
      }, _createSlots({
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
          modelValue: _unref(key_word),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(key_word) ? key_word.value = $event : null),
          placeholder: "请输入关键字"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_2, [_createElementVNode("ul", null, [__props.multiple ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(_unref(data_list), (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: index,
            onClick: $event => select_item_mutiple(item)
          }, [_createElementVNode("span", {
            class: _normalizeClass(['iconfont', item.is_show ? 'icon-fangxingxuanzhongfill' : 'icon-fangxingweixuanzhong'])
          }, null, 2), _createTextVNode(" " + _toDisplayString(item[_unref(label_filed)]) + " " + _toDisplayString(item.phone ? "/" + item.phone : ""), 1)], 8, _hoisted_3);
        }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(_unref(data_list), (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: index,
            onClick: $event => select_item(item)
          }, _toDisplayString(item[_unref(label_filed)]) + " " + _toDisplayString(item.phone ? "/" + item.phone : ""), 9, _hoisted_4);
        }), 128))])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_pagination, {
          "current-page": fy.page,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => fy.page = $event),
          "page-size": fy.limit,
          background: "",
          layout: "total,prev, pager, next",
          total: fy.total,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 2
      }, [__props.multiple ? {
        name: "footer",
        fn: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => _isRef(dialogVisible) ? dialogVisible.value = false : dialogVisible = false)
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handle_multiple
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 确定 ")])),
          _: 1
        })])]),
        key: "0"
      } : undefined]), 1032, ["modelValue", "title"])]);
    };
  }
};